import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=2e98753a&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=2e98753a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98753a",
  null
  
)

export default component.exports